export enum DeliveryLeaveAttributeType {
  NORMAL = 'NORMAL',
  TODAY = 'TODAY',
  OPTION_TODAY = 'OPTION_TODAY',
}
